import { render, staticRenderFns } from "./TitleViewSelector.vue?vue&type=template&id=3d45d740&scoped=true"
import script from "./TitleViewSelector.vue?vue&type=script&lang=js"
export * from "./TitleViewSelector.vue?vue&type=script&lang=js"
import style0 from "./TitleViewSelector.vue?vue&type=style&index=0&id=3d45d740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45d740",
  null
  
)

export default component.exports